import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import { useCurrentCurrency } from '@src/hooks/useCurrentCurrency';
import { PaymentMethod } from '@src/types';
import { getType } from '@src/utilities/activityHelper';
import { getSchoolName } from '@src/utilities/programHelper';
import { useLocale } from 'pe-core-frontend';
export const ActivityInfo = ({ activity, showUpdatedAt }) => {
    const currency = useCurrentCurrency({ clientId: activity.paymentRequest?.clientId });
    const { t, formatCurrency, formatToLocalDatetime } = useLocale();
    const { isProgram, isPaymentRequest } = getType(activity);
    const program = activity.program;
    let amountRequested;
    let amountPaid;
    if (isPaymentRequest) {
        amountRequested = Number(activity.paymentRequest?.amountRequested ?? 0);
        amountPaid = Number(activity.paymentRequest?.amountToPay ?? 0);
    }
    return (_jsxs("div", { className: 'flex flex-col', children: [showUpdatedAt && (_jsxs(Typography, { style: { fontSize: 12 }, children: [t('Updated on'), ": ", formatToLocalDatetime(activity.updatedAt, { dateStyle: 'medium' })] })), _jsx(Typography, { className: 'text-nowrap', children: isProgram
                    ? t('Program application')
                    : activity.paymentRequest?.paymentMethod === PaymentMethod.PREIMBURSEMENT
                        ? t('Advance payment')
                        : t('Reimbursement') }), _jsx(Typography, { weight: '700', children: t('{program} at {school}', {
                    values: { program: program.programName, school: getSchoolName(program) },
                }) }), _jsx(Typography, { className: 'text-nowrap', children: program.programLevelName }), isPaymentRequest && (_jsxs(_Fragment, { children: [_jsx(Typography, { className: 'text-nowrap', children: t('Amount requested: {amount}', {
                            values: {
                                amount: formatCurrency(amountRequested ?? 0, currency, true),
                            },
                        }) }), _jsx(Typography, { className: 'text-nowrap', children: t('Amount approved: {amount}', {
                            values: {
                                amount: formatCurrency(amountPaid ?? 0, currency, true),
                            },
                        }) })] }))] }));
};
